module.exports = __webpack_public_path__ + "media/images/application/favicon/logo-5c90d797abea10b79f6244630fb553d8.png";